/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M8.1427 9.087c.0633.223.1326.454.2077.6929l.881 2.8088H7.0692l.9645-3.128c.0376-.1216.074-.2462.109-.3737Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 8c0-4.4183 3.5817-8 8-8h8c4.4183 0 8 3.5817 8 8v8c0 4.4183-3.5817 8-8 8H8c-4.4183 0-8-3.5817-8-8V8Zm5.4386 9.6661 1.0802-3.3515h3.264l1.0654 3.3515h1.9546L9.0477 6.3h-1.808L3.5 17.6661h1.9386Zm8.8151-9.9232 2.1825.148v8.2287l-2.1825.1479v1.3986H20.5v-1.3985l-2.1752-.148V7.8909l2.1752-.148V6.3444h-6.2463v1.3985Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuAIFilled'
);
